import { Input } from 'components/elements';
import AgentSelectInput from 'legacy-modules/master/agent/components/select-input';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export default function InformationField() {
  const { t } = useTranslation();
  return (
    <FullContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="orderNumber"
            label={t('common:order_number')}
            placeholder={t('common:order_number')}
            required
            disabled
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="requestedAt"
            label={t('refund:requested_at')}
            placeholder={t('refund:requested_at')}
            required
            disabled
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <AgentSelectInput name="agentId" required disabled />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="number"
            name="refundAmount"
            label={t('refund:refund_amount')}
            placeholder={t('refund:refund_amount')}
            disabled
            required
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <FullContainer>
          <Input
            type="text"
            name="reason"
            label={t('refund:refund_reason')}
            placeholder={t('refund:refund_reason')}
            required
            disabled
          />
        </FullContainer>
      </SectionContainer>
      {/* <SectionContainer>
        <HalfContainer>
          <EnumSelectInput
            name="paymentName"
            label={t('refund:refund_type')}
            placeholder={t('refund:refund_type')}
            enumType="payment-method-type"
            required
          />
        </HalfContainer>
      </SectionContainer> */}
    </FullContainer>
  );
}
